import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CuratorLink = styled(Link)`
  &:hover {
    opacity: 0.8;
  }
`;
